import React, { useState } from "react";
import { useIsBlocked } from "./hooks/useIsBlocked";
import { useBlockHandler } from "./hooks/useBlockHandler";
import { ModalBlock } from "./shared/ModalBlock";
import { ModalUnblock } from "./shared/ModalUnblock";

export const Block = ({ userId }) => {
  const isBlocked = useIsBlocked(userId);
  const handler = useBlockHandler(userId);

  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showUnblockModal, setShowUnblockModal] = useState(false);

  return (
    <>
      <button
        type="button"
        className="new-red-btn pull-left m-l-10"
        onClick={() => {
          if (isBlocked) {
            setShowUnblockModal(true);
          } else {
            setShowBlockModal(true);
          }
        }}
      >
        {isBlocked ? "Unblock" : "Block"}
      </button>
      {showBlockModal && (
        <ModalBlock
          onSubmit={handler.block}
          onClose={() => setShowBlockModal(false)}
          isSubmitting={handler.isLoading}
        />
      )}
      {showUnblockModal && (
        <ModalUnblock
          onSubmit={handler.unblock}
          onClose={() => setShowUnblockModal(false)}
          isSubmitting={handler.isLoading}
        />
      )}
    </>
  );
};
